import { Button, Grid, Text } from '@chakra-ui/react';
import { memo } from 'react';

import { MessageType, SuggestionMessageProps } from '../Chat.types';

/**
 * Render the topic suggestion message in the ChatPanel
 *
 * @param data.messages[] list of suggested topics
 */
export const SuggestionMessage = memo(({ data, isDisabled = false, onUpdate }: SuggestionMessageProps) => {
  const handleClick = (topic: string) => {
    onUpdate(MessageType.SUGGESTION, topic, data);
  };

  const ChatSuggestionMessageTestId = 'chat-suggestion-message';

  return (
    <Grid
      templateColumns={{ base: 'unset', md: `repeat(${data.messages.length}, 1fr)` }}
      templateRows={{ base: `repeat(${data.messages.length}, 1fr)`, md: 'unset' }}
      gap='4'
      p='0.5'
      data-testid={ChatSuggestionMessageTestId}
    >
      {data.messages.map((topic, index) => {
        /**
         * [INFO–154] Visible label not included in programmatic name
         * The accessible team suggested to add the programatic topic to the front of the label
         */
        const label = `“${topic}” →`;
        const ariaLabel = `Suggested topic: ${topic}`;

        return (
          <Button
            key={index}
            isDisabled={isDisabled}
            variant='ghost'
            whiteSpace='normal'
            height='auto'
            bg='gray.50'
            py='4'
            px='2.5'
            borderRadius='base'
            border='2px'
            borderColor='gray.50'
            boxSizing='border-box'
            onClick={() => handleClick(topic)}
            _hover={{
              bg: 'upgrade.blue.50',
              borderColor: 'upgrade.blue.500',
            }}
            _active={{}}
            aria-label={ariaLabel}
          >
            <Text
              borderRadius='lg'
              textAlign='center'
              color='font.500'
              fontSize='md'
              fontWeight='medium'
              lineHeight='6'
            >
              {label}
            </Text>
          </Button>
        );
      })}
    </Grid>
  );
});

SuggestionMessage.displayName = 'SuggestionMessage';
